// PostDraftItem.js
'use strict';
import { connect } from 'react-redux';

import PostDraftItem from '../component/PostDraftItem.jsx';

import getAssetAverageProgress from '../selector/getAssetAverageProgress.js';
import getMessageData from '../selector/getMessageData.js';
import getUploadJobStatusI18nKey from '../selector/getUploadJobStatusI18nKey.js';
import getOperationData from '../selector/getOperationData.js';
import toggleUploadJobMoreModal from '../action/toggleUploadJobMoreModal.js';

const mapStateToProps = (state, { uploadJobId }) => {
  const messageId = getOperationData(
    state,
    ['uploadJob', uploadJobId],
    'messageId'
  );
  const assetIds = getMessageData(state, messageId, 'assetIds') || [];
  const assetId = assetIds[0];
  const aupAssetIds = getMessageData(state, messageId, 'aupAssetIds') || [];
  return {
    messageId,
    assetId,
    uploadJobStatus: getOperationData(
      state,
      ['uploadJob', uploadJobId],
      'status'
    ),
    uploadJobType: getOperationData(state, ['uploadJob', uploadJobId], 'type'),
    statusI18nKey: getUploadJobStatusI18nKey(state, uploadJobId),
    // TODO: adjust performance
    averageProgress: getAssetAverageProgress(state, [
      ...assetIds,
      ...aupAssetIds,
    ]),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleUploadJobMoreModal: ({ uploadJobId, isOpen }) =>
      dispatch(toggleUploadJobMoreModal({ uploadJobId, isOpen })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostDraftItem);
